export default "/images/terms_banner.png?19f1cb5b191d5b4adb9c5f732bf3ea50";